import * as React from "react";
import { createHashRouter, Navigate } from "react-router-dom";
import Settings from "@/router/modules/settings";
import Peoples from "@/router/modules/peoples";
import TravelClaims from "@/router/modules/travelClaims";
import Payroll from "@/router/modules/payroll";
import Separations from "@/router/modules/separations";
import ProtectedRoute from "@/router/protectedRoute";
import Leave from "@/router/modules/leave";
import Login from "@/pages/authentication/Login";
import ForgotPassword from "@/pages/forgotPassword/ForgotPassword";
import Movement from "./modules/movement";
import Profile from "@/router/modules/profile";
import Attendance from "@/router/modules/attendance/attendanceRoutes";
import Probations from "@/router/modules/probation";
import Events from "@/router/modules/event";
import Dashboard from "@/router/modules/dashboard/Index";
// import DashboardPage from "@/router/modules/dashboard/Index";
import WorkAnniversary from "@/router/modules/workAnniversary/Index";
import HelpDeskcomponent from "@/router/modules/helpdesk";
import EmployeeHoliday from "@/router/modules/holiday/Index";
import AttendanceManagement from "@/router/modules/attendanceManagement/Index";
import Policy from "./modules/policy/Index";
import HelpDeskReport from "@/router/modules/helpDeskReport/index";
import Salary from "@/router/modules/salary";
import Performance from "@/router/modules/pms";
import EmployeeListRouter from "./modules/employeeList/Index";
import LeaveManagement from "@/router/modules/leaveManagement/Index";
import HrMovement from "@/router/modules/hrMovement/Index";
import HrProbation from "@/router/modules/hrProbation/index";
import EmailIdCreationRouter from "@/router/modules/emailIdCreation/Index";
import OnboardingRouter from "@/router/modules/onBoarding/index";
import CandidateSeatingRouter from "@/router/modules/candidateSeating/Index";
import Onboardingcomponent from "@/router/modules/canditateOnboarding/index";
import ProjectWave from "@/router/modules/ProjectWave/index";
import Forms from "@/router/modules/forms/form";
import IIY from "@/router/modules/iiy";
import ChangePassword from "@/router/modules/changePassword/index";
import ErrorPage from "@/components/Error/ErrorPage";
import MailTemplateRouter from "@/router/modules/mailTemplate";
import ModuleSetting from "@/router/modules/moduleSettings";
import RecognizedRouter from "./modules/recognized";
import TroveRouter from "./modules/trove/Trove";
import MyDayAtWork from "@/router/modules/myDayatWork";
import TravelDashboard from "@/router/modules/traveldashboard";
import SuccessioPlan from "./modules/successionPlan";
import CompanyAssets from "./modules/companyAssets";
import AdminLunch from "./modules/adminLunch/adminLunch";
import withRoutes from "./RoutePermission";
import CareerProgression from "./modules/careerProgression";
import QuizRoutes from "./modules/quiz";
import DailyDoseRoutes from "./modules/dailyDose";
// import RoleFamilyRouter from "./modules/roleFamily";
import Resourceallocation from "./modules/resourceAllocation";
const RoutesChecking = withRoutes(ProtectedRoute);
const LoginRoute = () =>
  localStorage.getItem("isAuthenticated") === "true" ? (
    <Navigate to="/dashboard" />
  ) : (
    <Login />
  );

const router = [
  {
    path: "/",
    element: <RoutesChecking />,
    errorElement: <ProtectedRoute />,
    children: [
      ...Settings,
      ...Peoples,
      ...TravelClaims,
      ...Separations,
      ...Movement,
      ...Profile,
      ...Leave,
      ...Probations,
      ...Payroll,
      ...Attendance,
      ...Events,
      ...HelpDeskcomponent,
      ...Dashboard,
      ...EmployeeHoliday,
      // ...DashboardPage,
      ...WorkAnniversary,
      ...AttendanceManagement,
      ...Policy,
      ...HelpDeskReport,
      ...Salary,
      ...Performance,
      ...EmployeeListRouter,
      ...LeaveManagement,
      ...HrMovement,
      ...HrProbation,
      ...EmailIdCreationRouter,
      ...OnboardingRouter,
      ...CandidateSeatingRouter,
      ...Onboardingcomponent,
      ...ProjectWave,
      ...Forms,
      ...IIY,
      ...ChangePassword,
      ...MailTemplateRouter,
      ...ModuleSetting,
      ...RecognizedRouter,
      ...TroveRouter,
      ...MyDayAtWork,
      ...TravelDashboard,
      ...SuccessioPlan,
      ...CompanyAssets,
      ...AdminLunch,
      ...CareerProgression,
      ...QuizRoutes,
      ...DailyDoseRoutes,
      ...Resourceallocation,
      // ...RoleFamilyRouter,
    ],
  },
  {
    path: "/login",
    element: <LoginRoute />,
  },
  {
    path: "/forgotPassword",
    element: <ForgotPassword />,
  },
  {
    path: "/mismatch",
    element: <ErrorPage />,
  },
];

export default createHashRouter(router);
